export function BackgroundGradients() {
  return (
    <div className="fixed inset-0 -z-10 pointer-events-none overflow-hidden">
      {/* Base gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-indigo-900/30 via-slate-900 to-purple-900/30" />

      {/* Top-center radial glow — visible on all devices */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[600px] bg-radial-glow-top opacity-50" />

      {/* Bottom-right secondary glow for depth */}
      <div className="absolute bottom-0 right-0 w-[600px] h-[400px] bg-radial-glow-bottom opacity-30" />

      {/* Grid pattern — desktop only */}
      <div className="absolute inset-0 grid-pattern opacity-20 hidden md:block" />
    </div>
  );
}
